import { useCallback } from "react";
import { useParams } from "react-router";
import { useBuildLink } from "src/hooks/useBuildLink";
import type { ClusterRunPath } from "src/utils/appRoutes/appRoutes.types";

interface UseGetClusterRunUrlProps {
  run_time: string;
  task_id: number;
}

export const useGetClusterRunUrl = () => {
  const { app_name, cluster_name } = useParams();
  const buildLink = useBuildLink();

  return useCallback(
    ({ run_time, task_id }: UseGetClusterRunUrlProps) => {
      if (!app_name || !cluster_name) return;

      return buildLink({
        app_name,
        cluster_name,
        run_time,
        task_id,
        search: window.location.search,
      } as ClusterRunPath);
    },
    [app_name, cluster_name, buildLink]
  );
};
